import { render, staticRenderFns } from "./TypographyDescription.vue?vue&type=template&id=644112b6&"
import script from "./TypographyDescription.vue?vue&type=script&lang=js&"
export * from "./TypographyDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports